import React from 'react';
import MigrationDashboard from '../components/admin/MigrationDashboard';

const AdminMigrationPage = () => {
  return (
    <div className="admin-migration-page">
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-6">🔄 Panel de Migración</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <MigrationDashboard />
        </div>
      </div>
    </div>
  );
};

export default AdminMigrationPage;
